/** @format */

import { TextField } from '@mui/material';
import type { ContentEditorPart, PatchContentPartFn } from 'src/types';

interface ContentEditorBlockBodyScalarProps {
  part: ContentEditorPart;
  fieldKey: string;
  fieldLabel: string;
  onPatch: PatchContentPartFn;
}

export default function ContentEditorBlockBodyScalar({
  part,
  fieldKey,
  fieldLabel,
  onPatch
}: ContentEditorBlockBodyScalarProps) {
  const raw = (part as Record<string, unknown>)[fieldKey];
  const value = typeof raw === 'string' ? raw : raw != null ? String(raw) : '';
  return (
    <TextField
      fullWidth
      variant="outlined"
      margin="normal"
      label={fieldLabel}
      value={value}
      onChange={e => onPatch(part.id, { [fieldKey]: e.target.value })}
    />
  );
}
